import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/images/landing/bennefits/goblin-bennefits.webp'


const _hoisted_1 = { class: "relative py-24 sm:py-32 min-h-fit" }
const _hoisted_2 = { class: "mx-auto grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-16 sm:gap-y-20 items-center" }
const _hoisted_3 = { class: "lg:pt-4 lg:pr-8" }
const _hoisted_4 = { class: "lg:max-w-lg" }
const _hoisted_5 = { class: "mt-6 max-w-xl space-y-4 text-base lg:max-w-none" }
const _hoisted_6 = { class: "font-semibold text-gray-900 dark:text-white underline" }

import { useI18n } from 'vue-i18n';
import UiContainer from '@/components/ui/UiContainer.vue';
import UiTitle from '@/components/ui/UiTitle.vue';
import UiParagraph from '@/components/ui/UiParagraph.vue';
import { UserGroupIcon, CalendarIcon, DevicePhoneMobileIcon } from '@heroicons/vue/24/outline';


export default /*@__PURE__*/_defineComponent({
  __name: 'BennefitsSection',
  setup(__props) {

const { t } = useI18n();

// Computed
const features = (() => [
  {
    name: t('home.benefits.feature1.name'),
    description: t('home.benefits.feature1.description'),
    icon: UserGroupIcon,
  },
  {
    name: t('home.benefits.feature2.name'),
    description: t('home.benefits.feature2.description'),
    icon: CalendarIcon,
  },
  {
    name: t('home.benefits.feature3.name'),
    description: t('home.benefits.feature3.description'),
    icon: DevicePhoneMobileIcon,
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UiContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(UiTitle, {
                size: "5xl",
                type: "h2",
                code: _unref(t)('home.benefits.tag'),
                align: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('home.benefits.title')), 1)
                ]),
                _: 1
              }, 8, ["code"]),
              _createVNode(UiParagraph, {
                class: "mt-6",
                size: "lg",
                type: "p",
                align: "left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('home.benefits.description')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features(), (feature) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: feature.name,
                    class: "flex items-start gap-x-4"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(feature.icon), {
                      class: "h-6 w-6 mt-1 text-indigo-500 dark:text-indigo-400",
                      "aria-hidden": "true"
                    })),
                    _createVNode(UiParagraph, {
                      size: "base",
                      align: "left",
                      class: "flex-1 text-gray-600 dark:text-gray-300"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(feature.name), 1),
                        _createTextVNode(": " + _toDisplayString(' ' + feature.description), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pt-0 sm:pt-16" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Product screenshot",
              class: "mx-auto rounded-xl shadow-xl ring-1 ring-gray-400/10 max-h-full"
            })
          ], -1))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})